export default __webpack_public_path__ + "static/media/emoji_home.c3477246.svg";